module.exports = __webpack_public_path__ + "static/media/view post.f3f9b72a.svg";